import { Component, OnInit, ViewEncapsulation, Input, ViewChild, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-orders-notes-form',
    templateUrl: './orders-notes-form.component.html',
    styleUrls: ['./orders-notes-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class OrdersNotesFormComponent implements OnInit {

    @Input() notes: any;
    @Input() isPanelExpended: boolean;
    @Input() rfqData: any;
    @ViewChild('notesForm', { static: true }) notesForm: NgForm;
    houseBillNote: any;
    internalNote: any;
    isInternalNotesChanged = false;
    isHouseBillNotesChanged = false;
    rfqDetails: any;
    constructor() { }

    ngOnInit() {
        this.setDataForNotes();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['notes'] && this.notes) {
            this.setDataForNotes();
        }
        if (changes['rfqData'] && changes['rfqData'].currentValue) {
            this.rfqDetails = changes['rfqData'].currentValue;
            this.setDataForRFQ();
        }
    }

    setDataForNotes() {
        if (this.notes) {
            this.houseBillNote = this.notes.houseBillNote || '';
            this.internalNote = this.notes.internalNote || '';
            this.setDataForRFQ();
        }
    }

    setDataForRFQ() {
        if (this.notes && !this.notes.internalNote && this.rfqDetails) {
            this.internalNote = this.rfqDetails.specialInstruction;
        }
    }
    onHouseBillChange() {
        this.isHouseBillNotesChanged = true;
    }

    onInternalNotesChange() {
        this.isInternalNotesChanged = true;
    }
}
